module.exports = __webpack_public_path__ + "static/carbon-table-highlight-d04fedb950973ca54fcb0696b10e95a6.png";